import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getSelectedOrganization } from "toolkit/organizations/organizations.thunks";

export const useOrganization = (organizationId: number) => {
	const dispatch = useAppDispatch();

	const selectedOrganization = useAppSelector((state) => state.organizations.selectedOrganization);

	useEffect(() => {
		if (organizationId) {
			dispatch(getSelectedOrganization(organizationId));
		}
		//eslint-disable-next-line
	}, []);

	return selectedOrganization;
};
